<script setup lang="ts">
import { computed } from 'vue';
import { posStore } from '../../../../stores/posStore';
import Buttons from '../../../../components/ui/form/Buttons.vue';

const props = defineProps<{
  currentStep: number;
  totalSteps: number;
}>();

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'complete'): void
  (e: 'cancel'): void
  (e: 'update', print: boolean, share: boolean, delivery: boolean): void
}>()



const pos = posStore()

const nextButtonText = computed(() => {
  if (props.currentStep === 0) return 'Select Customer';
  if (props.currentStep === 1) return 'Add Delivery Info';
  if (props.currentStep === 2) return 'Select Products';
  if (props.currentStep === 3) return 'Select Payment Method';
  if (props.currentStep === 3) return 'Review the Order';

  if (props.currentStep === props.totalSteps) return 'Complete';
  return 'Continue';
});

const nextButtonDisabled = computed(() => {
  // Disable next button based on the current step validation
  switch (props.currentStep) {
    case 1: // Customer selection
      return !pos.selectedPosInvoice?.invoice.customer;
    case 2: // Delivery info
      const address = pos.selectedPosInvoice?.invoice.delivery_address_id || {};
      return !address;
    case 3: // Product selection
      return pos.selectedPosInvoice?.invoice.items.length === 0;
    case 4: // Payment method
      return pos.selectedPosInvoice?.invoice.payments.length === 0;
    default:
      return false;
  }
});

function goToNext() {
  if (props.currentStep === 5) {
    emit('complete')
    
  } else {
    // Emit next event to move to the next step
    emit('next');
  }
  //router.push(nextRoute.value);
}
</script>

<template>
  <div>
  <footer class="border-t border-neutral-200 p-2 z-10 fixed bottom-[60px] w-full pr-4">
    <!--<button 
      @click="goToNext" 
      v-if="currentStep < 5"
      class="btn btn-primary w-full py-3" 
      :class="{ 'opacity-50 cursor-not-allowed': nextButtonDisabled }"
      :disabled="nextButtonDisabled"
    >
      {{ nextButtonText }}
    </button>-->
    <div v-if="currentStep < 5" class="flex justify-between items-center">
      <div class="flex-[1_1_33%] text-left">
      <Buttons
        caption="Cancel"
        :display-text="true"
        icon="CircleX"
        @click="$emit('cancel')"
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-red-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      </div>
      <div class="flex-[1_1_67%] text-right flex justify-end">
      <Buttons
        :caption="nextButtonText"
        :disabled="nextButtonDisabled"
        :display-text="true"
        icon="CircleArrowRight"
        @click="goToNext" 
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      </div>
    </div>
    <div class="flex justify-between" v-else>
      <div>
      <Buttons
        caption="Cancel"
        icon="CircleX"
        :display-text="true"
        @click="$emit('cancel')"
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-red-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      </div>
      <div class="flex gap-3">
      <Buttons
        caption="Share"
        icon="Share2"
        :display-text="true"
        @click="$emit('update', false, true, false)"
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      <Buttons
        caption="Update"
        icon="Save"
        :display-text="true"
        @click="$emit('update', false, false, false)"
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      <Buttons
        caption="Print"
        icon="Printer"
        :display-text="true"
        @click="$emit('update', true, false, false)"
        className="px-2 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
      />
      </div>      
    </div>
  </footer>
</div>
</template>